/* global SideDrawer */

if (!customElements.get('learn-more-drawer')) {
    class LearnMoreDrawer extends SideDrawer {
      constructor() {
        super();
        this.documentClickHandler = this.handleDocumentClick.bind(this);
  
        const openers = document.querySelectorAll('a[data-learnmore-drawer]');
        openers && openers.forEach(el => el.addEventListener('click', this.documentClickHandler));
  
        const btns = this.querySelectorAll('a[href]');
        btns && btns.forEach(el => el.addEventListener('click', this.handleCollectionLink));
      }
  
      handleCollectionLink(evt) {
          if(!evt.target && !evt.target.href) return
  
          if (evt.currentTarget.href.includes('?filter')) {
              evt.preventDefault();
              let subcollection_title = evt.currentTarget.text;
              let subcollection_url = evt.currentTarget.href;
      
              if (evt.currentTarget.href.includes('?')) {
                const searchParams = new URLSearchParams('?' + evt.currentTarget.href.split('?')?.[1]);
                if (searchParams.has('filter.p.m.custom.product_type')) {
                  let title = searchParams.get('filter.p.m.custom.product_type');
                  if (title.includes('#')) title = title.split('#')?.[0]
                  subcollection_title = title;
                } else if (searchParams.has('filter.p.m.custom.wire_type')) {
                  let title = searchParams.get('filter.p.m.custom.wire_type');
                  if (title.includes('#')) title = title.split('#')?.[0]
                  subcollection_title = title;
                } else if (searchParams.has('filter.p.m.custom.amp_range')) {
                  let title = searchParams.get('filter.p.m.custom.amp_range');
                  if (title.includes('#')) title = title.split('#')?.[0]
                  subcollection_title = title;
                }
              }
      
              if (subcollection_title) {
                localStorage.setItem('currentSubcollection', subcollection_title);
                localStorage.setItem('currentSubcollectionUrl', subcollection_url);
              }
              if (sessionStorage.getItem("current_page").includes('/collections/') && sessionStorage.getItem("breadcrumb") != null) {
                sessionStorage.setItem("breadcrumb2", sessionStorage.getItem("breadcrumb"));
              }
              sessionStorage.removeItem("breadcrumb");
      
              if (evt.currentTarget.href.includes('/all-brands')) {
                window.location = evt.currentTarget.href;
              } else {
                window.location = evt.currentTarget.href + '&target=' + subcollection_title;
              }
          }
      }
  
      /**
       * Handles 'click' events on the document.
       * @param {object} evt - Event object.
       */
      handleDocumentClick(evt) {
        if(!evt.target.dataset && !evt.target.dataset.drawer) return
        evt.preventDefault()
  
        if(this && this.dataset.name == evt.target.dataset.learnmoreDrawer) this.open(evt.target)
      }
    }
  
    customElements.define('learn-more-drawer', LearnMoreDrawer);
  }